export default function convertDateTime(dateTimeString) {
  try {
    // Parse the input date and time string
    const dateTime = new Date(dateTimeString);

    // Thai month names
    const thaiMonths = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
      'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
      'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    // Format the date and time
    const day = dateTime.getUTCDate();
    const month = thaiMonths[dateTime.getUTCMonth()];
    const year = dateTime.getUTCFullYear() + 543; // Offset by 543 years for Thai calendar
    const hours = dateTime.getUTCHours();
    const minutes = dateTime.getUTCMinutes();
    const seconds = dateTime.getUTCSeconds();

    // Determine AM or PM
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert 24-hour time to 12-hour time
    const formattedHours = hours % 12 || 12;

    // Pad single-digit minutes and seconds with leading zeros
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    return `${day} ${month} ${year} เวลา ${formattedHours}:${formattedMinutes} ${ampm}`;
  }
  catch (err) {
    return "ไม่สามารถแปลงรูปแบบวันที่ได้"
  }
}

// const originalDateTime = "2023-10-02T07:10:41.100Z";
// const thaiPatternDateTime = formatDateAndTimeToThaiPattern(originalDateTime);
// console.log(thaiPatternDateTime); // Output: "2 ตุลาคม 2566 เวลา 2:10:41 PM"